import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import DataManagementSettings from "./DataManagementSettings";
import DataSyncSettings from "./DataSyncSettings";
import { useLegacyMode } from "../legacy/LegacyModeContext";
import { useEditorStatuses } from "./editorStatus";
import FitmentFieldsSettings from "./FitmentFieldsSettings";
import MetafieldAttributesSettings from "./MetafieldAttributesSettings";
import SettingsPageLayout from "./SettingsPageLayout";

const editors = ["sources", "attributes"] as const;

// Data tab: fitment data sources, product attributes, Shopify sync, then deletion.
export default function DataManagementSettingsPage() {
    const navigate = useNavigate();
    const [search, setSearch] = useSearchParams();
    const { report, form } = useEditorStatuses(editors);
    const { isLegacy } = useLegacyMode();
    // Imports links here with ?connect=turn14 to open the Turn14 connection once.
    const consumeTurn14AutoOpen = useCallback(() => setSearch(current => {
        const next = new URLSearchParams(current);
        next.delete("connect");
        return next;
    }, { replace: true }), [setSearch]);
    return (
        <SettingsPageLayout form={form}>
            {/* Phase 1: reference data and attributes feed the native storefront only. */}
            {!isLegacy && <>
                <FitmentFieldsSettings section="referenceData" onStatusChange={report.sources}
                    onOpenFitmentSpreadsheet={() => navigate("/imports?format=csv_xlsx")}
                    autoOpenTurn14={search.get("connect") === "turn14"} onTurn14AutoOpened={consumeTurn14AutoOpen} />
                <MetafieldAttributesSettings onStatusChange={report.attributes} />
            </>}
            <DataSyncSettings />
            <DataManagementSettings disabled={form.dirty} onExport={() => navigate("/imports?view=exports")} />
        </SettingsPageLayout>
    );
}
